import React, { useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../constants/app.constants";
import SearchFilterComponent from "../../../Common/SearchFilterComponent/SearchFilterComponent";
import SelectedFilters from "../../../Common/SearchFilterComponent/selected-filters.component";
import styles from "./MspAccountsHeader.module.scss";
import ManageViewDropdown from "./ManageViewDropdown";
import { FilterLineComponent } from "./filter-line-component";
import ArrowIcon from "../../../icons/arrow.icon";
import ViewSelectorDropdown from "./ViewSelectorDropdown";
import FiltersDropdown from "./FiltersDropdown";
import { SelectRowsDropdown } from "./SelectRowsDropdown";
import { SelectedAccountsActionsBottomModal } from "../components/action-line/selected-accounts-actions-bottom-modal";
import { ChangeStatusModal } from "../components/action-line/modals/change-status-modal";
import { ChangeTagsModal } from "../components/action-line/modals/change-tags-modal";
import { AssignModal } from "../components/action-line/modals/asign-modal";
import { ArchiveModal } from "../components/action-line/modals/archive-modal";

const MspAccountsHeader = ({
  variant = "v1",
  totalClients,
  listDataLoading,
  searchString,
  searchInputRef,
  handleInputChange,
  setSearchInput,
  tableFilters,
  addFilter,
  headersList,
  setHeadersList,
  getPageData,
  sortData,
  sortRecords,
  onInviteClick,
  selectedFilters,
  setSelectedFilters,
  dateFormat,
  isArchived = false,
  selectedRows = [],
  onBulkAction,
  onSelectRows,
  forceShowCheckboxes = false,
  isDistributorView = false,
}) => {
  const navigate = useNavigate();
  const viewCount = useMemo(() => {
    return headersList?.filter((item) => item?.Visibility === true)?.length || 0;
  }, [headersList]);

  const [manageViewFilters, setManageViewFilters] = useState([
    { id: "option-1", label: "Option 1", checked: true },
    { id: "option-2", label: "Option 2", checked: false },
  ]);

  const [showChangeStatusModal, setShowChangeStatusModal] = useState(false);
  const [showChangeTagsModal, setShowChangeTagsModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);

  if (variant === "v2") {
    return (
      <>
        <div className="p-2" />
        <div className={styles.actionBar} role="toolbar" aria-label="Action bar">
          {
            isArchived ? <ArchivedLeftSide /> : (
          <h1 className={styles.title}>
            {totalClients} {isDistributorView ? "Distributors" : "Accounts"}
            {listDataLoading && (
              <Spinner
                animation="border"
                variant="secondary"
                size="sm"
                style={{
                  width: "14px",
                  height: "14px",
                  marginLeft: "8px",
                }}
              />
            )}
          </h1>
            )
          }

          <div className={styles.actionsContainer}>
            {!isArchived && (
              <>
                <div
                  className={styles.iconButtonArchive}
                  aria-label="Archive"
                  onClick={() => {
                    navigate(`${ROUTE_PATHS.subscriptionPortalPages.mspArchivedAccounts}?variant=v2`);
                  }}
                >
                  <div className={styles.iconButtonArchiveInner}>
                    <img
                      src="/images/actioncenter/folder.svg"
                      alt=""
                      className={styles.iconButtonArchiveIcon}
                    />
                  </div>
                </div>

                <div className={styles.viewSelectorGroup}>
                  <ViewSelectorDropdown viewCount={viewCount} />

                  <ManageViewDropdown
                    filters={manageViewFilters}
                    onFilterChange={setManageViewFilters}
                  />
                </div>
              </>
            )}

            <div className={styles.toolbarGroup}>
              <div
                className={styles.toolbarButton}
                aria-label="Search"
                onClick={() => {
                  if (searchInputRef?.current) {
                    searchInputRef.current.focus();
                    setSearchInput(true);
                  }
                }}
              >
                <div className={styles.toolbarButtonInner}>
                  <img
                    src="/images/attack-surface/search-icon.svg"
                    alt=""
                    className={styles.toolbarButtonIcon}
                    width={16}
                    height={16}
                  />
                </div>
              </div>

              <FiltersDropdown
                tableFilters={tableFilters}
                addFilter={addFilter}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
              />

              <div
                className={styles.toolbarButton}
                aria-label="Sort"
                onClick={() => {
                  sortRecords(sortData.sortItem);
                }}
              >
                <div className={styles.toolbarButtonInner}>
                  <img
                    src="/images/sort-icon.svg"
                    alt=""
                    className={styles.toolbarButtonIcon}
                    width={16}
                    height={16}
                  />
                </div>
              </div>
            </div>

            <div
              className={styles.addButton}
              aria-label="Add account"
              onClick={onInviteClick}
            >
              <div className={styles.addButtonInner}>
                <span className={styles.addButtonText}>Add</span>
              </div>
            </div>

            {selectedRows.length > 0 ? (
                <SelectRowsDropdown 
                  onSelectRows={onSelectRows} 
                  hasSelectedRows={true}
                  onChangeStatusClick={() => setShowChangeStatusModal(true)}
                  onChangeTagsClick={() => setShowChangeTagsModal(true)}
                  onAssignClick={() => setShowAssignModal(true)}
                  onArchiveClick={() => setShowArchiveModal(true)}
                />
            ) : (
              <SelectRowsDropdown 
                onSelectRows={onSelectRows} 
                hasSelectedRows={false}
                onChangeStatusClick={() => setShowChangeStatusModal(true)}
                onChangeTagsClick={() => setShowChangeTagsModal(true)}
                onAssignClick={() => setShowAssignModal(true)}
                onArchiveClick={() => setShowArchiveModal(true)}
              />
            )}
          </div>
        </div>
        {/* <SelectedFilters
          filterList={selectedFilters}
          onFilterChange={setSelectedFilters}
          onReset={() => {
            setSelectedFilters([]);
          }}
          dateFormat={dateFormat}
        /> */}
        <FilterLineComponent 
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          isDistributorView={isDistributorView}
        />
        <SelectedAccountsActionsBottomModal
          show={forceShowCheckboxes || selectedRows.length >= 2}
          onHide={() => {
            // Clear selection when modal is closed
            if (onBulkAction) {
              onBulkAction("close");
            }
          }}
          selectedCount={selectedRows.length}
          onStatusClick={() => setShowChangeStatusModal(true)}
          onTagClick={() => setShowChangeTagsModal(true)}
          onAssignClick={() => setShowAssignModal(true)}
          onArchiveClick={() => setShowArchiveModal(true)}
          showStatusModal={showChangeStatusModal}
          showTagsModal={showChangeTagsModal}
          showAssignModal={showAssignModal}
          showArchiveModal={showArchiveModal}
        />
        <ChangeStatusModal
          show={showChangeStatusModal}
          onHide={() => setShowChangeStatusModal(false)}
        />
        <ChangeTagsModal
          show={showChangeTagsModal}
          onHide={() => setShowChangeTagsModal(false)}
        />
        <AssignModal
          show={showAssignModal}
          onHide={() => setShowAssignModal(false)}
          onSave={(salesRep) => {
            console.log("Assigning to:", salesRep);
            // Add your assignment logic here
          }}
        />
        <ArchiveModal
          show={showArchiveModal}
          onHide={() => setShowArchiveModal(false)}
          onSave={() => {
            console.log("Archiving accounts");
            // Add your archive logic here
          }}
          companyNames={selectedRows.map((row) => row.companyName || "[Company Name]")}
        />
      </>
    );
  }

  if (isArchived) {
    return <ArchivedHeader 
      totalClients={totalClients}
      listDataLoading={listDataLoading}
      searchString={searchString}
      searchInputRef={searchInputRef}
      handleInputChange={handleInputChange}
      setSearchInput={setSearchInput}
      tableFilters={tableFilters}
      addFilter={addFilter}
      headersList={headersList}
      setHeadersList={setHeadersList}
      getPageData={getPageData}
      sortData={sortData}
      sortRecords={sortRecords}
      selectedFilters={selectedFilters}
      setSelectedFilters={setSelectedFilters}
      dateFormat={dateFormat}
    />;
  }

  return (
    <>
      <div className="p-2" />
      <div className="d-flex align-items-center justify-content-between clients-header">
        <div className="f-16 f-600 d-flex align-items-center gap-8">
          <span className="d-none d-sm-block">
            {totalClients} MSP Accounts
          </span>
          {listDataLoading && (
            <Spinner
              animation="border"
              variant="secondary"
              size="sm"
              style={{
                width: "14px",
                height: "14px",
              }}
            />
          )}
        </div>
        {/* Filter section */}
        <SearchFilterComponent
          leftSide={
            <div
              className="pointer mr-2 f-grey f-500"
              onClick={() => {
                navigate(ROUTE_PATHS.subscriptionPortalPages.mspArchivedAccounts);
              }}
            >
              <img
                src="/images/actioncenter/folder.svg"
                alt=""
                className="mr-2"
              />
              Archived
            </div>
          }
          searchValue={searchString}
          searchOnChange={(e) => {
            setSearchInput(true);
            handleInputChange(e);
          }}
          searchOnCross={() => {
            handleInputChange({ target: { value: "" } });
          }}
          passedRef={searchInputRef}
          setRef={() => {
            searchInputRef.current.focus();
          }}
          passedFilterList={tableFilters}
          onFilterClick={addFilter}
          orderData={headersList}
          setOrderData={(e) => {
            setHeadersList(e);
            getPageData({
              AccountSortVisibility_List: JSON.stringify(e),
              ClientNumber: 0,
            });
          }}
          onSortClick={() => {
            sortRecords(sortData.sortItem);
          }}
          lastButtonOnClick={onInviteClick}
        />
      </div>
      <SelectedFilters
        filterList={selectedFilters}
        onFilterChange={setSelectedFilters}
        onReset={() => {
          setSelectedFilters([]);
        }}
        dateFormat={dateFormat}
      />
    </>
  );
};

export default MspAccountsHeader;

export const ArchivedLeftSide = () => {
  const navigate = useNavigate();

  const handleBackToList = () => {
    navigate(`${ROUTE_PATHS.subscriptionPortalPages.mspAccounts}?variant=v2`);
  };

  return (
    <div className={styles.archivedNav}>
      <div className={styles.archivedBackButton} onClick={handleBackToList}

      >
        <span className={styles.archivedIconWrapper}>
          <ArrowIcon className={styles.archivedBackArrow} fill="#616778" />
        </span>

        <span className={styles.archivedTextWrapper}>
          <span className={styles.archivedBackText}>
            Back to list
          </span>
        </span>
      </div>

      <div className={styles.archivedActiveButton}  >
        <span className={styles.archivedIconWrapper}>
          <img
            src="/images/actioncenter/folder.svg"
            alt=""
            className={styles.archivedIcon}
          />
        </span>

        <span className={styles.archivedTextWrapper}>
          <span className={styles.archivedActiveText}>
            Archived
          </span>
        </span>
      </div>
    </div>
  );
};

const ArchivedHeader = ({
  totalClients,
  listDataLoading,
  searchString,
  searchInputRef,
  handleInputChange,
  setSearchInput,
  tableFilters,
  addFilter,
  headersList,
  setHeadersList,
  getPageData,
  sortData,
  sortRecords,
  selectedFilters,
  setSelectedFilters,
  dateFormat,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="p-2" />
      <div className="d-flex align-items-center justify-content-between clients-header">
        <div className="f-16 f-600 d-flex align-items-center gap-8">
          <span className="d-none d-sm-block">
            {totalClients} MSP's Archived Accounts
          </span>
          {listDataLoading && (
            <Spinner
              animation="border"
              variant="secondary"
              size="sm"
              style={{
                width: "14px",
                height: "14px",
              }}
            />
          )}
        </div>
        {/* Filter section */}
        <div className="d-flex align-items-center">
          <SearchFilterComponent
            leftSide={
              <div
                className="pointer mr-2 f-grey f-500"
                onClick={() => {
                  navigate(ROUTE_PATHS.subscriptionPortalPages.mspArchivedAccounts);
                }}
              >
                <img
                  src="/images/actioncenter/folder.svg"
                  alt=""
                  className="mr-2"
                />
                Archived
              </div>
            }
            searchValue={searchString}
            searchOnChange={(e) => {
              setSearchInput(true);
              handleInputChange(e);
            }}
            searchOnCross={() => {
              handleInputChange({ target: { value: "" } });
            }}
            passedRef={searchInputRef}
            setRef={() => {
              searchInputRef.current.focus();
            }}
            passedFilterList={tableFilters}
            onFilterClick={addFilter}
            orderData={headersList}
            setOrderData={(e) => {
              setHeadersList(e);
              getPageData({
                AccountSortVisibility_List: JSON.stringify(e),
                ClientNumber: 0,
              });
            }}
            onSortClick={() => {
              sortRecords(sortData.sortItem);
            }}
          />
        </div>
      </div>
      <SelectedFilters
        filterList={selectedFilters}
        onFilterChange={setSelectedFilters}
        onReset={() => {
          setSelectedFilters([]);
        }}
        dateFormat={dateFormat}
      />
    </>
  );
};